import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    title?: string;
    containerClassName?: string;
    variant?: 'default' | 'white';
    error?: string;
}

export default function Input({ title, containerClassName = '', className = '', variant = 'default', error, ...props }: InputProps) {
    const bgClass = variant === 'white' ? 'bg-white focus:bg-white' : 'bg-gray-50 focus:bg-white';
    return (
        <div className={`flex flex-col gap-1 ${containerClassName}`}>
            {title && (
                <label htmlFor={props.id} className="block text-secondary font-semibold">
                    {title}
                    {props.required && <span className="text-red-500 ml-0.5">*</span>}
                </label>
            )}
            <input
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#151515] focus:border-[#151515] outline-none transition-colors ${bgClass} placeholder-[#52525B] text-[14px] ${
                    error ? 'border-red-500' : 'border-[#D2D2D2]'
                } ${className}`}
                {...props}
            />
            {error && <span className="text-[11px] font-medium text-red-500">{error}</span>}
        </div>
    );
}

export type { InputProps };
